import starburstGif from '../../assets/img/starburst.gif';
import DabBot from '../../assets/img/robot-dab.gif';
import Success from '../../assets/img/congrats-banner.png';
import FlyBot from '../../assets/img/flying-robot.png';
import ThreeMail from '../../assets/img/3-letters-to-3-bureaus.png';
import Self from '../../assets/img/mailman-self.png';
import EnhancedBoxer from '../../assets/img/enhanced-boxer-bot.png';
import MailingBot from '../../assets/img/mailing-bot.png';
import CelebrateBot from '../../assets/img/celebrate-bot.png';
import useWindowSize from 'react-use/lib/useWindowSize';
import React, { useEffect, useState } from 'react';
import { Button, Modal, Image } from 'react-bootstrap';
import './SuccessPopup.module.css';
import Confetti from 'react-confetti';
import moment from 'moment';

const SuccessPopup = ({ startDate, endDate, setClosed, plan }) => {
  const { width, height } = useWindowSize();
  const [show, setShow] = useState(true);
  const [confetti, setConfetti] = useState(false);

  useEffect(() => {
    window?.history.replaceState({ ...window?.history.state, usr: null }, window?.location.pathname);
  }, []);

  const handleClose = () => {
    setShow(false);
    setClosed();
    setConfetti(false);
  };

  const handleConfetti = () => {
    setConfetti(true);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size='lg' onEnter={handleConfetti}>
        <div
          className='modal-content-custom'
          style={{
            backgroundImage: `url(${starburstGif})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
          }}>
          <Modal.Header className='border-0' closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='bg-transparent rounded-3 border-0 d-flex flex-column justify-content-center text-center'>
              <Image src={Success} className='mx-auto w-80' />
              {plan === 3 && <Image src={FlyBot} className='mx-auto w-40' />}
              {plan === 1 && <Image src={Self} className='mx-auto w-40' />}
              {/* <Image src={CelebrateBot} className='mx-auto w-40' /> */}
              {plan === 2 && <Image src={ThreeMail} className='mx-auto w-40' />}
              <h2 className='text-primary bg-white'>
                MAIL HAS BEEN SENT DISPUTE CYCLE OFFICIALLY STARTED ({moment(startDate || new Date()).format('MM/DD/YYYY')}) AND WILL END ON - {moment(endDate || moment().add(35, 'days')).format('MM/DD/YYYY')}
              </h2>
            </div>
          </Modal.Body>
          <Modal.Footer className='border-0 d-flex flex-row justify-content-center'>
            <Image src={DabBot} width={100} />
            <Image src={DabBot} width={100} />
            <Image src={DabBot} width={100} />
            <Image src={DabBot} width={100} />
            <Image src={DabBot} width={100} />
            {/* <Button variant='secondary' onClick={handleClose}>
              Close
            </Button> */}
          </Modal.Footer>
        </div>
      </Modal>
      {confetti && <Confetti width={width} height={height} />}
    </>
  );
};

export default SuccessPopup;
